import React, { Fragment, useState } from 'react';
import BrandLogo from './widgets/BrandLogo';
import MenuItem from './widgets/MenuItem';
import Drawer from '../constants/Drawer';
import InputTextBox from '../constants/InputTextBox';
import LinkItem from './widgets/LinkItem';
import { BiSearch } from 'react-icons/bi';
import { IconName, ImportMenuIcon } from '../constants/MenuIcons';
import { useSidebar } from '../helpers/sidebarClose';

interface SubSubMenu {
  sub_sub_m_id: number;
  name: string;
  link: string;
  showmenu: boolean;
  sidedrawer: boolean;
  tap_rpt: boolean;
}
interface SubMenu {
  sub_m_id: number;
  name: string;
  subsubmenus: SubSubMenu[];
}
interface Menu {
  menu_id: number;
  name: string;
  icon: IconName;
  submenus: SubMenu[];
}
interface AppSidebarProps {
  data: Menu[];
}
const AppSidebar: React.FC<AppSidebarProps> = ({ data }) => {
  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { closeAll } = useSidebar();

  const toggleDrawer = (menu_id: number) => {
    closeAll();
    setTimeout(() => {
      setOpenMenuId(prevMenuId => {
        const newMenuId = prevMenuId === menu_id ? null : menu_id;
        return newMenuId;
      });
    }, 0);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };
  return (
    <div className='border-r px-0.5 sm:px-1 divide-y divide-slate-200 dark:divide-sky-900 md:px-1 xl:px-1 xxl:px-1 dark:bg-sky_850 border-gray-200 dark:border-sky-900 border-solid bg-white z-[9999] sticky'>
      <BrandLogo />
      {Array.isArray(data) && data?.map((menu) => (
        <Fragment key={menu?.menu_id}>
          <MenuItem
            menu_title={menu?.name}
            menu_icon={<ImportMenuIcon icon={menu.icon} />}
            onClick={() => toggleDrawer(menu.menu_id)}
          />
          <Drawer
            open={openMenuId === menu.menu_id}
            close={() => setOpenMenuId(null)}
            position='left'
            className='pl-20'
            header={<InputTextBox
              type='text'
              prefix={<BiSearch />}
              name='search'
              placeholder='Search'
              value={searchTerm}
              handleChange={handleSearchChange}
              required={false}
            />}
          >
            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3'>
              {menu.submenus.map((submenu) => (
                <div key={submenu.sub_m_id}>
                  <h2 className='font-condensed uppercase font-bold text-gray-700 dark:text-gray-400 text-sm'>{submenu.name}</h2>
                  <div className='py-2'>
                    <ul>
                      {submenu.subsubmenus
                        .filter(subsubmenu =>
                          subsubmenu.name.toLowerCase().includes(searchTerm.toLowerCase())
                        )
                        .map((subsubmenu) => (
                          <Fragment key={subsubmenu.sub_sub_m_id}>
                            {subsubmenu.showmenu === true && 
                              <LinkItem
                                onClick={() => setOpenMenuId(null)}
                                label={subsubmenu.name}
                                link={subsubmenu.link}
                              />
                            }
                          </Fragment>
                        ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </Drawer>
        </Fragment>
      ))}
    </div>
  )
}

export default AppSidebar;
